import { POST } from 'src/network/apiHandler';
import config from 'src/globals';
import { GET_IMAGE_URL } from 'src/api/routes';
import { getErrorMessage } from 'src/utils/utils';

import axios from 'axios';

const { API_BASE_URL } = config;

export const getDocumentImageURL = async (body) => {
  return POST(`${API_BASE_URL}${GET_IMAGE_URL}`, body);
};

export const putImageS3 = async (url, file, content_type) => {
  try {
    const response = await axios.put(url, file, {
      headers: {
        'Content-Type': content_type,
      },
    });
    return {
      isSuccess: true,
    };
  } catch (err) {
    const errorMessage = getErrorMessage(err);
    return {
      errorMessage,
      isSuccess: false,
    };
  }
};
